/**
 * Daftar kata tidak pantas (Bahasa Indonesia & umum).
 * Tambah atau kurangi kata sesuai kebutuhan — satu kata per baris.
 */
export const profanityList = [
  // Kata kasar umum
  'anjing',
  'anjir',
  'asu',
  'bajingan',
  'bangsat',
  'babi',
  'brengsek',
  'goblok',
  'idiot',
  'keparat',
  'kampret',
  'monyet',
  'sialan',
  'setan',
  'tai',
  'tahi',
  'tolol',

  // Kata vulgar / seksual
  'bokep',
  'coli',
  'colmek',
  'kontol',
  'lonte',
  'memek',
  'ngentot',
  'pelacur',
  'pepek',

  // Varian umum
  'jancok',
  'jancuk',
  'dancok',
];

/**
 * Memeriksa apakah teks mengandung kata tidak pantas.
 * @param {string} text - Teks yang ingin diperiksa.
 * @returns {boolean} true jika teks mengandung kata tidak pantas.
 */
export function containsProfanity(text) {
  if (!text) return false;
  const lower = text.toLowerCase();
  return profanityList.some(word => {
    // Escape karakter regex khusus lalu buat pattern batas kata
    const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp(`(^|\\s|[^a-z])${escaped}($|\\s|[^a-z])`, 'i');
    return pattern.test(lower);
  });
}
